import http from "@/utils/http.js"

export function getUrlLink(data) {
    return http({
        url: "/api/web/home/getUrlLink",
        data: data,
        method: "GET",
    })
}
